'use es6';

import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["showCta", "title"];
import PropTypes from 'prop-types';
import I18n from 'I18n';
import { Tooltip } from 'foundations-components/transitional/components/Tooltip';
import { jsx as _jsx } from "react/jsx-runtime";
const propTypes = {
  children: PropTypes.node,
  showCta: PropTypes.bool.isRequired,
  title: PropTypes.string.isRequired
};
const defaultProps = {
  showCta: false
};
const BasePermissionTooltip = props => {
  // props BasePermissionTooltip cares about
  const {
      showCta,
      title
    } = props,
    rest = _objectWithoutPropertiesLoose(props, _excluded);

  // UITooltip specific props
  const {
    autoPlacement,
    Content,
    defaultOpen,
    delay,
    delayOnHold,
    disabled,
    headingText,
    onClose,
    onOpenChange,
    open,
    placement,
    target,
    use
  } = rest;
  let tooltipTitle = title;
  if (showCta) {
    tooltipTitle = `${title} ${I18n.text('customerDataUiUtilities.PermissionTooltip.cta')}`;
  }
  return /*#__PURE__*/_jsx(Tooltip, {
    autoPlacement: autoPlacement,
    Content: Content,
    defaultOpen: defaultOpen,
    delay: delay,
    delayOnHold: delayOnHold,
    disabled: disabled,
    headingText: headingText,
    onClose: onClose,
    onOpenChange: onOpenChange,
    open: open,
    placement: placement,
    target: target,
    use: use,
    title: tooltipTitle,
    children: props.children
  });
};
BasePermissionTooltip.propTypes = propTypes;
/* eslint-disable-next-line hubspot-dev/no-default-props-assignment */
BasePermissionTooltip.defaultProps = defaultProps;
export default BasePermissionTooltip;